var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfxQ1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_840_6849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25.5C19.4036 25.5 25 19.9036 25 13C25 6.09644 19.4036 0.5 12.5 0.5C5.59644 0.5 0 6.09644 0 13C0 19.9036 5.59644 25.5 12.5 25.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2006 5.99805H20.5332L15.6778 11.0323C13.9198 12.855 11.0697 12.855 9.31553 11.0323L4.46013 5.99805H6.7927L10.4799 9.82225C11.5948 10.9752 13.3985 10.9752 14.5096 9.82225L18.2006 5.99805ZM6.76226 20.0011H4.42969L9.31553 14.9326C11.0735 13.1099 13.9236 13.1099 15.6816 14.9326L20.5674 20.0011H18.2349L14.5172 16.1426C13.4023 14.9897 11.5986 14.9897 10.4875 16.1426L6.76226 20.0011Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_840_6849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfxQ1);
export default __webpack_public_path__ + "static/media/bfx_q (1).d77cfab12edfc933e12d833f2f3978b4.svg";
export { ForwardRef as ReactComponent };